import { render, staticRenderFns } from "./SelectAddonGroups.vue?vue&type=template&id=5555cd98&scoped=true&"
import script from "./SelectAddonGroups.vue?vue&type=script&lang=js&"
export * from "./SelectAddonGroups.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=5555cd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555cd98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5555cd98')) {
      api.createRecord('5555cd98', component.options)
    } else {
      api.reload('5555cd98', component.options)
    }
    module.hot.accept("./SelectAddonGroups.vue?vue&type=template&id=5555cd98&scoped=true&", function () {
      api.rerender('5555cd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SelectAddonGroups.vue"
export default component.exports